var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-body"},[(_vm.$route.params.permissions)?_c('b-table',{attrs:{"show-empty":"","items":_vm.$route.params.permissions,"fields":_vm.fields}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }